/**
 * REPORT-SCREENSHOT-REPARTITION.WIDGET.TSX
 * Preview of the slide for the repartition widget
 */
import Space from "@/components/space"
import DashboardRepartitionWidget from "./dashboard-repartition.widget"

interface OwnProps {
  isFullWidth?: boolean
  isReport?: boolean
}

function ReportScreenshotRepartitionWidget(props: OwnProps) {
  return (
    <div
      className="flex"
      style={{
        marginTop: 0,
        transform: props.isFullWidth ? "scale(0.90)" : "scale(0.75)",
        transformOrigin: "top left"
      }}>
      <Space />
      <DashboardRepartitionWidget isOverview isReport={props.isReport} />
      <Space />
    </div>
  )
}

export default ReportScreenshotRepartitionWidget
